import { useTranslation } from "@msuite/ui/localization";
import { moment } from "@msuite/utils/date";
import type { IncomingInvoiceEventListItem } from "@msuite/utils/types";
import { UserCard } from "@/components/cards";
import { IncomingInvoiceTimelineItemDetails } from "./incoming-invoice-timeline-item-details";
import { EVENT_LABEL } from "./timeline-event-labels";

/** Props Interface */
interface IncomingInvoiceTimelineItemProps {
	event: IncomingInvoiceEventListItem;
}

/** One event: who did it — a person, or the system — what, when, and what it carried. */
export function IncomingInvoiceTimelineItem({ event }: IncomingInvoiceTimelineItemProps) {
	/** Context */
	const { t } = useTranslation();

	/** Render */
	return (
		<div
			className="card v-stack gap-1"
			data-cy={`incoming-invoice-event-${event.type}`}
		>
			<div className="h-stack items-center gap-1 flex-wrap">
				{event.actorId ? (
					<UserCard
						userId={event.actorId}
						variant="plain"
						fontSize="md"
					/>
				) : (
					<p className="font-medium">{t("incoming_invoices.events.system")}</p>
				)}
				<p>{t(EVENT_LABEL[event.type])}</p>
				<div className="flex-1" />
				<p className="label">{moment(event.occurredAt).format("LT")}</p>
			</div>
			<IncomingInvoiceTimelineItemDetails event={event} />
		</div>
	);
}
